/**
 * Tiroir latéral « Qu'est-ce qu'un parallélisme ? » — .zg-parallelisme-help-trigger
 */
(function () {
  const BODY_CLASS = "zg-parallelisme-drawer-open";

  function getDrawer() {
    return document.getElementById("zg-parallelisme-drawer");
  }

  function openDrawer() {
    const root = getDrawer();
    if (!root) return;
    const panel = root.querySelector(".zg-parallelisme-drawer__panel");
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add(BODY_CLASS);
    requestAnimationFrame(() => {
      root.classList.add("is-open");
      if (panel && typeof panel.focus === "function") {
        try {
          panel.focus();
        } catch (e) {
          /* */
        }
      }
    });
  }

  function closeDrawer() {
    const root = getDrawer();
    if (!root) return;
    root.classList.remove("is-open");
    document.body.classList.remove(BODY_CLASS);
    window.setTimeout(() => {
      if (!root.classList.contains("is-open")) {
        root.hidden = true;
        root.setAttribute("aria-hidden", "true");
      }
    }, 350);
  }

  function init() {
    const root = getDrawer();
    if (!root) return;

    document.addEventListener(
      "click",
      function (e) {
        const trigger = e.target.closest(".zg-parallelisme-help-trigger");
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      },
      true,
    );

    root.querySelectorAll("[data-zg-parallelisme-drawer-close]").forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (root.hidden || !root.classList.contains("is-open")) return;
      closeDrawer();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
